import { ApplicationEventType } from '../enums';

export interface ApplicationEvent {
  performedBy: string;
  entity: string;
  type: ApplicationEventType;
  occurredAt: Date;
}

export namespace ApplicationEvent {
  export function mapFromApiValue({ type, ...restOfApplicationEvent }: any): ApplicationEvent {
    return {
      ...restOfApplicationEvent,
      type: ApplicationEventType.mapFromApiValue(type),
    };
  }
}
